<dashlet
  title="New Users"
  [loading]="loading"
  [noResults]="!listResults?.length && !loading"
  >
  <ng-container filter>
    <time-filter
      [DateRange]="DateRange"
      [dateSize]="dateSize"
      (onSetDateSize)="setDateSize($event)"
      (onIncrementStartDate)="incrementStartDate()"
      (onDecrementStartDate)="decrementStartDate()"
      (onStartDateToday)="startDateToday()"
      >
    </time-filter>
  </ng-container>

  <ng-container data>
    @if (!loading) {
      <mat-card class="header">
        <mat-card-content> New Users: {{ newUsers }} </mat-card-content>
      </mat-card>
    }

    @if (!loading) {
      <mat-card class="header">
        <mat-card-content> Total Users: {{ totalUsers }} </mat-card-content>
      </mat-card>
    }
  </ng-container>
</dashlet>
